'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionViewQuilt = function ActionViewQuilt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z' })
  );
};
ActionViewQuilt = (0, _pure2.default)(ActionViewQuilt);
ActionViewQuilt.displayName = 'ActionViewQuilt';

exports.default = ActionViewQuilt;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/view-quilt.js
 ** module id = 1157
 ** module chunks = 0
 **/